import { Component, OnInit, Input } from '@angular/core';
import { Constants } from '../../../shared/models/constants';
import * as _ from "lodash";
import { EBEpouchdbService } from '../../../EBE/EBEpouchdb.service';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';

@Component({
  selector: 'app-mini-book',
  templateUrl: './mini-book.component.html',
  styleUrls: ['./mini-book.component.css']
})
export class MiniBookComponent implements OnInit {
  @Input() data: any;
  public currentSelectedBookThumbs = [];
  public selectedThumbs = [];
  public isCreateMiniBook : boolean = false;
  public bookTemplates;
  public bookTemplateDetails;
  public bookThemId;
  public selectedThemeInd = undefined;
  bookNameErr = false;
  ebeMBookTitle = '';
  creationsShelf;
  creationsBooksArr = [];
  public selectedBookThumbInd;
  public selectedBookObj;
  public MBookType = 0;
  myTemplatesArr;

  constructor(private EBEpouchdbService:EBEpouchdbService,private ElectronService:IS_ElectronService) {
    if(!this.ElectronService.IS_ELECTRON){
      this.bookTemplates = Constants.getBookTemplatesArr();
      this.bookTemplateDetails = Constants.getTemplates();
    }
    else{
      this.bookTemplates = Constants.getElectronBookTemplatesArr();
      this.bookTemplateDetails = Constants.getElectronTemplates();
    }
   }

  ngOnInit() {
   
    if (this.data.popupProps.bookObj) {
     // for (var i = 1; i <= this.data.popupProps.bookObj.pageCount; i++) {
      for (var i = 1; i <= 116; i++) {
        // if (i < 10) {
        //   var url = "http://hyd.semanoor.com/NooorM/pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/Thumbs/PDF-00" + i + ".JPG";
        // }
        // else if (i > 99) {
        //   var url = "http://hyd.semanoor.com/NooorM/pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/Thumbs/PDF-" + i + ".JPG";
        // }
        // else {
        //   var url = "http://hyd.semanoor.com/NooorM/pdf/d4c1f754-d3f2-4c7a-bf1d-cf16d2a8c2c8/Thumbs/PDF-0" + i + ".JPG";
        // }
        var url = "http://hyd.semanoor.com/NooorM/pdfImages/"+i+".png";
        var obj = {
          isThumbActive: false,
          url: url
        }
        this.currentSelectedBookThumbs.push(obj);
      }
    }

    var mycompthis = parent.window.document['mycompthis'];
    var ind = _.findIndex(mycompthis.myContentElements, function (o) { return o['title'] == 'Creations' });
    this.creationsShelf = mycompthis.myContentElements[ind];
    this.EBEpouchdbService.getCreationBooksData(this,this.creationsShelf );

  }
  selectCreatingMBookType(evt)
  {
    this.MBookType = evt.index;
  }

  onThumbClick(thumb, evt) {

    evt.stopPropagation();

    thumb.isThumbActive = !thumb.isThumbActive;

    if (thumb.isThumbActive) {
      this.selectedThumbs.push(thumb);
    }
    else {
      var indOfThumb = this.selectedThumbs.findIndex(x => x.url == thumb.url);
      if (indOfThumb != -1) {
        this.selectedThumbs.splice(indOfThumb, 1);
      }
    }

  }
  onBookThumbClick(bk,ind,evt)
  {  
    this.selectedBookThumbInd = ind;
    this.selectedBookObj = bk;
  }

  updateCreationsBooks(books){
    this.creationsBooksArr = _.map(_.filter(books, function (book) { return book.bookType == 1;}));
   // this.creationsBooksArr = books;   
  }

  addMyTemplateCoverPage(book) {
    var myCompThis = parent.window.document['mycompthis'];
    this.myTemplatesArr = myCompThis.cteatedMytemplates;

    var index = _.findIndex(this.myTemplatesArr, function (o: any) { return o._id == book.templateId; });
    if (index > -1) {
      return this.myTemplatesArr[index].cover.thumbUrl;
    }
  }

  hideMiniBookDialog() {    
      this.data.popupProps.showPopup = false;   
  }
  clickNext()
  {   
    this.isCreateMiniBook = true;   
  }

  back() {
    this.isCreateMiniBook = false;
  }

  updateSelectedTheme(ind, id) {
    this.selectedThemeInd = ind;
    this.bookThemId = id;
  }
  cancelSelectedTheme(ind, id) {
    this.selectedThemeInd = undefined;
    this.bookThemId = undefined;
  }
  createNewMBook(name) {
    this.bookNameErr = false;
    if (name == '') {
      this.bookNameErr = true;
      return;
    }
    var obj = {
      themeId: this.bookThemId,    
      name: name,
      thumbs: this.selectedThumbs
    }
    this.data.popupProps.curComp.createNewMiniBook(obj);
    this.hideMiniBookDialog();
   
  }
  createExistingMBook()
  {
    var obj = {
      book:this.selectedBookObj,
      thumbs: this.selectedThumbs
    }
    this.data.popupProps.curComp.createExistingMiniBook(obj);
    this.hideMiniBookDialog();
  }

}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/mini-book/mini-book.component.ts